module.exports = __webpack_public_path__ + "static/media/solar-cells-before.png";